import JooxterLogo from '../../assets/images/JooxterLogo.png';
import JxtContainer from '../JxtContainer';
import { ContainerSizeEnum } from '../JxtContainer/types';
import { useErrorMessage } from './hooks';
import { IJxtError } from './types';

const JxtError = ({ code, className, children }: IJxtError) => {
  const { title, message } = useErrorMessage(code);

  return (
    <JxtContainer size={ContainerSizeEnum.Small} className={className}>
      <div className="flex flex-col p-4">
        <header className="flex flex-col justify-center">
          <img src={JooxterLogo} alt="Jooxter logo" className="h-32 object-contain" />
          <h3 className="text-title-l font-medium text-neutral-140 mt-6 mb-3">{title}</h3>
        </header>
        <section>
          <p className="text-body-m font-light text-neutral-120"> {message}</p>
        </section>
        {children && <footer className="flex flex-wrap items-center gap-3 mt-6">{children}</footer>}
      </div>
    </JxtContainer>
  );
};

export default JxtError;
